import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
  data: [],
  isUpdating: false,
  status: null,
};

const token = userObj?.token;

export const updateRcs = createAsyncThunk(
  "pickups/updateRcs",
  async (id, data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/Order/updateRcs`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (err) {
      console.log(err.response);
      return rejectWithValue(err.response.data);
    }
  }
);

const updateRcsSlice = createSlice({
  name: "updateRcs",
  initialState,
  reducers: {},
  extraReducers: {
    [updateRcs.pending]: (state, action) => {
      state.status = "pending";
      state.isUpdating = true;
    },
    [updateRcs.fulfilled]: (state, action) => {
      state.status = "success";
      state.isUpdating = false;
      state.data = action.payload;
      // localStorage.setItem('user', JSON.stringify(action.payload))
    },

    [updateRcs.rejected]: (state, action) => {
      state.status = "failed";
      state.isUpdating = false;
    },
  },
});

export default updateRcsSlice.reducer;
